const setUserData = async (userData) => {

  try {
    global.userData = userData;
    await localStorage.setItem("@userData", JSON.stringify(userData));
  } catch (e) {
    throw new Error(e);
  }
};

const getUserData = () => {
  return new Promise((resolve) => {
    try {
      global.userData = null;
      const value = localStorage.getItem("@userData");
      if (value !== null) {
        global.userData = JSON.parse(value);
        resolve(true);
      } else {
        resolve(false);
      }
    } catch (e) {
      resolve(false);
      throw new Error(e);
    }
  });
};

const logOutUser = () => {
  localStorage.removeItem("@userData");
  localStorage.clear();
}

const Storage = {
  setUserData,
  getUserData,
  logOutUser
};

export default Storage;
